/*
  Y2K Hero 3D — sections/y2k-hero.liquid (CLAUDE.md §8)
  Sahne: podyum + spot + ortam (korunur). İçerik: "Vitrin ayakkabısı"
  block'larından gelen GLB modeller; yükleme hatasında prosedürel ayakkabı
  (blob fallback).

  SAĞLAMLIK SÖZLEŞMESİ — "ne 3D ne fallback" durumu OLUŞAMAZ:
  1. three.min.js ya da bu dosya yüklenemezse -> script onerror (liquid'de) no3d basar.
  2. window.THREE yoksa ya da init hata fırlatırsa -> no3d.
  3. init'ten 3 sn sonra tek frame bile çizilmemişse -> watchdog no3d basar.
  İlk başarılı frame no3d'yi geri temizler (kendini onarır).
  GLB katmanı bu sözleşmenin DIŞINDA: ilk model yüklenemezse no3d DEĞİL,
  blob fallback devreye girer (podyum + ışık zaten çiziliyor).

  ETKİLEŞİM (§8.4):
  - Boşta yavaş otomatik dönüş; sürüklerken durur, bırakınca atalet,
    2.5 sn etkileşimsizlikte yumuşak rampayla geri başlar.
  - Masaüstü: tut-sürükle (grab/grabbing imleci). Mobil: yatay parmak döndürür;
    dikey jest sayfayı kaydırır (canvas touch-action: pan-y + yön kilidi).
  - Yatay 360° serbest; dikey eğim ±15°. Zoom/pan yok.
  - 38.1 (2026-10-17, kullanıcı kararı): otomatik dönüş + model geçişi
    prefers-reduced-motion'dan BAĞIMSIZ — her cihazda aynı davranış (Windows'ta
    "Animasyon efektleri" kapalı masaüstlerinde Chrome reduce bildiriyor ve
    vitrin duruyordu). reduce açıkken iki fark: dönüş hızı yarı (REDUCE_SPEED_K)
    ve 38.3'ten beri fare parallax'ı kapalı (sahne imleci izlemez, düz duruşa
    süzülür); ayar sayfa açıkken değişirse anında uygulanır.
  - Sahne viewport dışında ya da sekme arka plandayken render durur.

  VİTRİN ROTASYONU (§8.6):
  - Birden çok block varsa modeller SWITCH_MS arayla XFADE_S cross-fade ile
    değişir (8.10: podyum altı ürün adı kullanıcı isteğiyle kaldırıldı —
    vitrin salt görsel, tıklama navigasyon yapmaz).
  - Kullanıcı etkileşimdeyse ya da son INTERACT_HOLDOFF içinde etkileştiyse
    geçiş ertelenir; etkileşim bitince kaldığı yerden sürer.
  - Sonraki modeller ilk model gösterildikten sonra sırayla önden yüklenir;
    yüklenemeyen block rotasyondan düşer. Turntable (yaw/pitch) geçişte
    sıfırlanmaz — sahne dönmeye devam eder, ayakkabı değişir.

  TEMA EDİTÖRÜ:
  - shopify:section:load  -> aktif sahnenin stage'i söküldüyse dispose + yeni init.
  - shopify:section:unload -> sahne dispose edilir.
  - Shopify.designMode'da IntersectionObserver beklenmez, hemen init edilir.
  - Çift init koruması: stage başına data-y2k-init bayrağı.
*/
(function () {
  'use strict';

  // 38.1: reduce dönüş/geçişi kapatmaz — hız yarı (38.3: + fare parallax'ı kapalı)
  var reduceMq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var REDUCE = !!(reduceMq && reduceMq.matches);
  if (reduceMq) {
    var onReduce = function (e) { REDUCE = e.matches; };
    if (reduceMq.addEventListener) reduceMq.addEventListener('change', onReduce);
    else if (reduceMq.addListener) reduceMq.addListener(onReduce);
  }

  /* Etkileşim sabitleri (§8.4) */
  var AUTO_SPEED = 0.27;              // rad/sn — eski 0.0045/frame @60fps ile aynı
  var REDUCE_SPEED_K = 0.5;           // 38.1: reduce'da dönüş normalin yarısı
  var DRAG_K = 0.008;                 // rad/px yatay
  var PITCH_K = 0.004;                // rad/px dikey
  var PITCH_MAX = 15 * Math.PI / 180; // ±15° eğim sınırı
  var RESUME_MS = 2500;               // otomatik dönüşe geri dönme eşiği
  var LOCK_PX = 8;                    // yön kilidi eşiği (px)
  var VEL_EPS = 0.02;                 // atalet bitti sayılan hız (rad/sn)
  var FADE_S = 0.5;                   // ilk model belirme süresi (sn)

  /* Vitrin rotasyonu (§8.6) */
  var SWITCH_MS = 3000;               // her model sahnede bu kadar kalır
  var XFADE_S = 0.7;                  // modeller arası cross-fade süresi (sn)
  var INTERACT_HOLDOFF = 5000;        // son etkileşimden sonra geçiş ertelemesi

  /* Model yerleşimi: blob ile aynı görsel ağırlık (§8.2) */
  var TARGET_LEN = 3.4;               // blob taban uzunluğu ~3.46 birimdi
  var MAX_H = 2.2;                    // kadraj güvenliği: yükseklik tavanı
  var PEDESTAL_TOP = -0.21;           // podyum silindirinin üst yüzü (y=-0.42 + 0.42/2)
  var PIVOT_Y = 0.55;                 // eğim (pitch) pivotu — ayakkabı gövde merkezi
  var MODEL_YAW0 = Math.PI - 0.55;    // açılış duruşu
  var LOAD_TIMEOUT_MS = 12000;        // ilk model ağda takılırsa blob'a düş

  var state = null; // aktif sahne durumu (tek 3D sahne kuralı)

  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function setNo3d(on) {
    document.body.classList.toggle('no3d', on);
  }

  function clamp(v, lo, hi) {
    return v < lo ? lo : v > hi ? hi : v;
  }

  /* ---------- Sökme: editörde section yeniden yüklenince sızıntı olmasın ---------- */
  function disposeObject(obj) {
    obj.traverse(function (o) {
      if (o.geometry) o.geometry.dispose();
      if (o.material) {
        var mats = Array.isArray(o.material) ? o.material : [o.material];
        for (var i = 0; i < mats.length; i++) {
          for (var k in mats[i]) {
            if (mats[i][k] && mats[i][k].isTexture) mats[i][k].dispose();
          }
          mats[i].dispose();
        }
      }
    });
  }

  function teardown() {
    if (!state) return;
    var s = state;
    state = null;
    s.running = false;
    if (s.raf) cancelAnimationFrame(s.raf);
    if (s.watchdog) clearTimeout(s.watchdog);
    if (s.loadTimer) clearTimeout(s.loadTimer);
    for (var i = 0; i < s.off.length; i++) s.off[i]();
    if (s.io) s.io.disconnect();
    if (s.stage) s.stage.classList.remove('is-dragging');
    // Sahnedekiler + önden yüklenmiş ama o an sahnede olmayan holder'lar
    if (s.scene) disposeObject(s.scene);
    for (var m = 0; m < (s.models ? s.models.length : 0); m++) {
      if (s.models[m].holder && (!s.scene || s.models[m].holder.parent !== s.spin)) {
        disposeObject(s.models[m].holder);
      }
    }
    if (s.renderer) {
      try {
        s.renderer.dispose();
        var el = s.renderer.domElement;
        if (el && el.parentNode) el.parentNode.removeChild(el);
      } catch (e) { /* dispose hatası önemsiz */ }
    }
    if (s.stage && s.stage.dataset) delete s.stage.dataset.y2kInit;
  }

  /* ---------- Blob fallback geometrisi (referanstan, y2k: hepsi normalMat) ---------- */
  function buildShoe(normalMat) {
    var g = new THREE.Group();

    // Taban — extrude edilmiş yan profil
    var s = new THREE.Shape();
    s.moveTo(-1.55, 0.0);
    s.quadraticCurveTo(-1.72, 0.02, -1.66, 0.16);
    s.quadraticCurveTo(-1.2, 0.30, 0.2, 0.24);
    s.quadraticCurveTo(1.25, 0.20, 1.58, 0.08);
    s.quadraticCurveTo(1.68, 0.02, 1.52, -0.05);
    s.lineTo(-1.4, -0.05);
    s.quadraticCurveTo(-1.58, -0.05, -1.55, 0.0);
    var soleGeo = new THREE.ExtrudeGeometry(s, {
      depth: 0.66,
      bevelEnabled: true,
      bevelThickness: 0.05,
      bevelSize: 0.06,
      bevelSegments: 3,
      curveSegments: 24
    });
    soleGeo.center();
    var sole = new THREE.Mesh(soleGeo, normalMat);
    sole.castShadow = true;
    sole.position.y = 0.02;
    g.add(sole);

    // Dış taban şeridi
    var out = new THREE.Mesh(new THREE.BoxGeometry(3.02, 0.07, 0.68), normalMat);
    out.castShadow = true;
    out.position.y = -0.14;
    g.add(out);

    // Saya — ezilmiş küreler
    var body = new THREE.Mesh(new THREE.SphereGeometry(0.8, 28, 20), normalMat);
    body.castShadow = true;
    body.scale.set(1.32, 0.62, 0.5);
    body.position.set(-0.12, 0.44, 0);
    g.add(body);

    var toe = new THREE.Mesh(new THREE.SphereGeometry(0.62, 28, 20), normalMat);
    toe.castShadow = true;
    toe.scale.set(1.02, 0.55, 0.52);
    toe.position.set(0.92, 0.30, 0);
    g.add(toe);

    var heel = new THREE.Mesh(new THREE.SphereGeometry(0.55, 28, 20), normalMat);
    heel.castShadow = true;
    heel.scale.set(0.78, 0.95, 0.5);
    heel.position.set(-1.08, 0.52, 0);
    g.add(heel);

    // Burun koruması
    var cap = new THREE.Mesh(new THREE.SphereGeometry(0.45, 24, 16), normalMat);
    cap.castShadow = true;
    cap.scale.set(0.72, 0.5, 0.56);
    cap.position.set(1.22, 0.22, 0);
    g.add(cap);

    // Bilek yakası
    var collar = new THREE.Mesh(new THREE.TorusGeometry(0.3, 0.085, 12, 28), normalMat);
    collar.castShadow = true;
    collar.rotation.x = Math.PI / 2;
    collar.scale.set(1, 0.85, 1);
    collar.position.set(-1.02, 0.86, 0);
    g.add(collar);

    // Dil
    var tongue = new THREE.Mesh(new THREE.BoxGeometry(0.46, 0.09, 0.34), normalMat);
    tongue.castShadow = true;
    tongue.rotation.z = -0.62;
    tongue.position.set(0.32, 0.72, 0);
    g.add(tongue);

    // Bağcıklar
    for (var i = 0; i < 4; i++) {
      var lace = new THREE.Mesh(new THREE.CylinderGeometry(0.032, 0.032, 0.5, 10), normalMat);
      lace.castShadow = true;
      lace.rotation.x = Math.PI / 2;
      lace.rotation.z = (i % 2 ? 0.12 : -0.12);
      lace.position.set(0.5 - 0.3 * i, 0.6 + 0.085 * i, 0);
      g.add(lace);
    }

    // Topuk şeridi
    var tab = new THREE.Mesh(new THREE.BoxGeometry(0.14, 0.3, 0.16), normalMat);
    tab.castShadow = true;
    tab.position.set(-1.44, 0.72, 0);
    tab.rotation.z = 0.12;
    g.add(tab);

    // Yan paneller
    var barL = new THREE.Mesh(new THREE.BoxGeometry(0.85, 0.16, 0.03), normalMat);
    barL.castShadow = true;
    barL.rotation.z = -0.28;
    barL.position.set(0.12, 0.4, 0.3);
    g.add(barL);
    var barR = new THREE.Mesh(new THREE.BoxGeometry(0.85, 0.16, 0.03), normalMat);
    barR.castShadow = true;
    barR.rotation.z = -0.28;
    barR.position.set(0.12, 0.4, -0.3);
    g.add(barR);

    g.rotation.y = -0.55;
    return g;
  }

  /* ---------- Render döngüsü ---------- */
  function shouldLoop(s) {
    // Görünürlük her şeyin önünde: ekran dışı/gizli sekmede atalet, fade ve
    // rotasyon da durur (IO/visibilitychange görünür olunca devam ettirir)
    // görünürken otomatik dönüş her kipte sürdüğü için döngü hep döner
    return s.onScreen && s.tabVisible;
  }

  function ensureLoop(s) {
    if (!s || state !== s || s.raf || !shouldLoop(s)) return;
    var now = performance.now();
    // Duraklamadan dönüşte model geçişi kapıda bekliyorduysa hemen basmasın
    if (s.rotNextAt && now - (s.lastTickAt || 0) > 800) {
      s.rotNextAt = Math.max(s.rotNextAt, now + 1200);
    }
    s.lastT = now;
    s.raf = requestAnimationFrame(function (n) { tick(s, n); });
  }

  function render(s) {
    s.renderer.render(s.scene, s.camera);
    s.frames++;
    if (s.frames === 1) setNo3d(false); // ilk frame: kendini onar
  }

  function setStageLabel(s, isModel) {
    // 8.10: ürün adı/podyum linki kaldırıldı — etiket yalnız içerik türünü söyler
    s.stage.setAttribute('aria-label',
      isModel ? '3D ayakkabı modeli' : 'Dönen 3D krom ayakkabı');
  }

  function tick(s, now) {
    s.raf = 0;
    if (state !== s) return;
    var dt = clamp((now - s.lastT) / 1000, 0.001, 0.05);
    s.lastT = now;
    s.lastTickAt = now;

    // Atalet: bırakınca hız sönümlenir
    if (!s.dragging && Math.abs(s.vel) > VEL_EPS) {
      s.yaw += s.vel * dt;
      s.vel *= Math.exp(-3.2 * dt);
      if (Math.abs(s.vel) <= VEL_EPS) s.vel = 0;
    }

    // Otomatik dönüş: etkileşimden RESUME_MS sonra yumuşak rampayla geri
    var wantAuto = !s.dragging && Math.abs(s.vel) < 0.05 &&
      (now - s.lastInteractAt > RESUME_MS);
    s.autoFactor += ((wantAuto ? 1 : 0) - s.autoFactor) * Math.min(1, dt * 1.6);
    if (s.autoFactor > 0.001) {
      s.yaw += AUTO_SPEED * (REDUCE ? REDUCE_SPEED_K : 1) * s.autoFactor * dt;
      // eğimi vitrin duruşuna geri süz (vitrin illüzyonu korunur)
      s.pitch += (0 - s.pitch) * Math.min(1, dt * 2) * s.autoFactor;
    }
    s.spin.rotation.y = s.yaw;
    s.tilt.rotation.x = s.pitch;

    // İlk model belirmesi (FADE_S sn; 38.1'den beri reduce'da da)
    if (s.fade) {
      s.fade.t += dt;
      var k = Math.min(1, s.fade.t / FADE_S);
      k = k * k * (3 - 2 * k); // smoothstep
      for (var i = 0; i < s.fade.mats.length; i++) {
        s.fade.mats[i].mat.opacity = s.fade.mats[i].opacity * k;
      }
      if (k >= 1) {
        for (var j = 0; j < s.fade.mats.length; j++) {
          s.fade.mats[j].mat.transparent = s.fade.mats[j].transparent;
          s.fade.mats[j].mat.opacity = s.fade.mats[j].opacity;
        }
        for (var q = 0; q < s.fade.meshes.length; q++) {
          s.fade.meshes[q].castShadow = true;
        }
        s.fade = null;
        // Rotasyon saati ilk model tam göründüğünde kurulur
        if (s.models.length > 1) s.rotNextAt = now + SWITCH_MS;
      }
    }

    // Vitrin rotasyonu: cross-fade sürüyor mu?
    if (s.xfade) {
      var x = s.xfade;
      x.t += dt;
      var xk = Math.min(1, x.t / XFADE_S);
      xk = xk * xk * (3 - 2 * xk); // smoothstep
      for (var a = 0; a < x.out.mats.length; a++) {
        x.out.mats[a].mat.opacity = x.out.mats[a].opacity * (1 - xk);
      }
      for (var b = 0; b < x.inn.mats.length; b++) {
        x.inn.mats[b].mat.opacity = x.inn.mats[b].opacity * xk;
      }
      if (!x.mid && xk >= 0.5) {
        x.mid = true;
        // Gölge geçişin ortasında el değiştirir (iki model üst üsteyken
        // fark edilmez; gölge opacity ile solamıyor — r128)
        for (var c = 0; c < x.out.meshes.length; c++) x.out.meshes[c].castShadow = false;
        for (var d = 0; d < x.inn.meshes.length; d++) x.inn.meshes[d].castShadow = true;
      }
      if (xk >= 1) {
        s.spin.remove(x.out.holder);
        for (var e2 = 0; e2 < x.out.mats.length; e2++) {
          x.out.mats[e2].mat.transparent = x.out.mats[e2].transparent;
          x.out.mats[e2].mat.opacity = x.out.mats[e2].opacity;
        }
        for (var f = 0; f < x.inn.mats.length; f++) {
          x.inn.mats[f].mat.transparent = x.inn.mats[f].transparent;
          x.inn.mats[f].mat.opacity = x.inn.mats[f].opacity;
        }
        s.xfade = null;
        s.rotNextAt = now + SWITCH_MS;
      }
    } else if (s.rotNextAt && now >= s.rotNextAt &&
               s.models.length > 1 && !s.blob && !s.fade) {
      // Geçiş vakti — ama kullanıcı etkileşimdeyse/az önce etkileştiyse ertele
      // (§8.6): her tick yeniden denenir, etkileşim bitince kendiliğinden geçer
      var idleOk = !s.dragging && Math.abs(s.vel) < 0.05 &&
        (now - s.lastInteractAt > INTERACT_HOLDOFF);
      if (idleOk) {
        var nxt = nextReadyIndex(s);
        if (nxt >= 0) startXfade(s, nxt);
        else s.rotNextAt = now + 1000; // hazır model yok — kısa ertele
      }
    }

    // Blob boşta yüzer (model podyuma oturur, bob yok)
    if (s.blob) {
      s.t += dt * 0.48;
      s.blob.position.y = 0.3 + Math.sin(s.t * 2) * 0.045;
    }

    // Parallax (eski 0.04/frame lerp'in dt eşdeğeri).
    // 38.3: reduce'da kapalı — hedef düz duruş (0); ayar sayfa açıkken açılırsa
    // sahne aynı yumuşaklıkla düzelir, kapanırsa imleci yeniden izler.
    var pk = 1 - Math.exp(-2.45 * dt);
    var px = REDUCE ? 0 : s.mouseX, py = REDUCE ? 0 : s.mouseY;
    s.rig.rotation.y += (px * 0.3 - s.rig.rotation.y) * pk;
    s.rig.rotation.x += (py * 0.14 - s.rig.rotation.x) * pk;

    render(s);
    if (shouldLoop(s)) {
      s.raf = requestAnimationFrame(function (n) { tick(s, n); });
    }
  }

  /* ---------- Vitrin listesi + model hazırlama ---------- */
  function readVitrinList(stage) {
    var wrap = stage.parentNode || document;
    var items = wrap.querySelectorAll('[data-y2k-vitrin-item]');
    var list = [];
    for (var i = 0; i < items.length; i++) {
      list.push({
        glb: items[i].getAttribute('data-glb') || '',
        status: 'idle', // idle | loading | ready | failed
        holder: null,
        mats: null,
        meshes: null
      });
    }
    return list;
  }

  function nextReadyIndex(s) {
    var n = s.models.length;
    for (var step = 1; step < n; step++) {
      var i = (s.current + step) % n;
      if (s.models[i].status === 'ready') return i;
    }
    return -1;
  }

  // GLB sahne nesnesini podyuma oturan, fade edilebilir holder'a çevirir
  function buildHolder(s, gltf) {
    var obj = gltf.scene;
    obj.updateMatrixWorld(true);

    // Otomatik yerleşim: merkezle, blob görsel ağırlığına ölçekle, tabanı
    // podyum üstüne oturt (farklı GLB'ler elle ayar istemesin)
    var box = new THREE.Box3().setFromObject(obj);
    var size = box.getSize(new THREE.Vector3());
    var center = box.getCenter(new THREE.Vector3());
    var sc = TARGET_LEN / (Math.max(size.x, size.z) || 1);
    if (size.y * sc > MAX_H) sc = MAX_H / size.y;

    var maxAniso = s.renderer.capabilities.getMaxAnisotropy();
    var mats = [];
    var meshes = [];
    obj.traverse(function (o) {
      if (!o.isMesh) return;
      // r128 gölge geçişi opacity'yi yok sayar: gölge, model tam görününce
      // (fade sonu / cross-fade ortası) açılır
      o.castShadow = false;
      meshes.push(o);
      var list = Array.isArray(o.material) ? o.material : [o.material];
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.map) m.map.anisotropy = Math.min(8, maxAniso);
        var seen = false;
        for (var j = 0; j < mats.length; j++) if (mats[j].mat === m) seen = true;
        if (!seen) mats.push({ mat: m, transparent: m.transparent, opacity: m.opacity });
      }
    });

    var holder = new THREE.Group();
    obj.position.set(-center.x, -box.min.y, -center.z);
    holder.add(obj);
    holder.scale.setScalar(sc);
    holder.position.y = PEDESTAL_TOP;
    holder.rotation.y = MODEL_YAW0;
    return { holder: holder, mats: mats, meshes: meshes };
  }

  function startXfade(s, nxt) {
    var out = s.models[s.current];
    var inn = s.models[nxt];
    for (var i = 0; i < inn.mats.length; i++) {
      inn.mats[i].mat.transparent = true;
      inn.mats[i].mat.opacity = 0;
    }
    for (var j = 0; j < out.mats.length; j++) {
      out.mats[j].mat.transparent = true;
    }
    s.spin.add(inn.holder);
    s.xfade = { t: 0, out: out, inn: inn, mid: false };
    s.current = nxt;
    s.content = inn.holder;
    ensureLoop(s);
  }

  /* ---------- İlk model / blob ---------- */
  function addBlobFallback(s) {
    if (state !== s || s.content) return;
    // Ekran okuyucu etiketi içerikle senkron kalsın: blob = krom ayakkabı
    setStageLabel(s, false);
    s.blob = buildShoe(new THREE.MeshNormalMaterial());
    s.blob.scale.setScalar(1.06);
    s.blob.position.y = 0.3;
    s.content = s.blob;
    s.spin.add(s.blob);
    render(s);
    ensureLoop(s);
  }

  function showFirst(s, entry) {
    if (state !== s || s.content) return;
    setStageLabel(s, true);

    for (var i = 0; i < entry.mats.length; i++) {
      entry.mats[i].mat.transparent = true;
      entry.mats[i].mat.opacity = 0;
    }
    s.fade = { t: 0, mats: entry.mats, meshes: entry.meshes };

    s.content = entry.holder;
    s.spin.add(entry.holder);
    render(s);
    ensureLoop(s);
    // Kalan modeller boşta önden yüklensin
    loadNextIdle(s);
  }

  function loadEntry(s, i, done) {
    var entry = s.models[i];
    entry.status = 'loading';
    var loader = new THREE.GLTFLoader();
    if (window.MeshoptDecoder) loader.setMeshoptDecoder(window.MeshoptDecoder);
    loader.load(
      entry.glb,
      function (gltf) {
        if (state !== s) return;
        var built = buildHolder(s, gltf);
        entry.holder = built.holder;
        entry.mats = built.mats;
        entry.meshes = built.meshes;
        entry.status = 'ready';
        if (done) done(true);
      },
      undefined,
      function (err) {
        if (state !== s) return;
        entry.status = 'failed';
        if (window.console && console.warn) {
          console.warn('Y2K hero: GLB yüklenemedi (' + entry.glb + ')', err);
        }
        if (done) done(false);
      }
    );
  }

  function loadNextIdle(s) {
    for (var i = 0; i < s.models.length; i++) {
      if (s.models[i].status === 'idle') {
        loadEntry(s, i, function () { loadNextIdle(s); });
        return;
      }
    }
  }

  function loadFirst(s) {
    if (!window.THREE || !THREE.GLTFLoader || !s.models.length) {
      addBlobFallback(s);
      return;
    }
    // LCP koruması: sayfa hâlâ yükleniyorsa GLB indirmesi kritik kaynaklarla
    // bant genişliği yarıştırmasın — load'dan sonra başla
    function begin() {
      if (state !== s) return;
      // Ağ takılırsa bekletme: blob göster; model geç gelirse yerini alır
      s.loadTimer = setTimeout(function () { addBlobFallback(s); }, LOAD_TIMEOUT_MS);
      loadEntry(s, 0, function (ok) {
        clearTimeout(s.loadTimer);
        if (state !== s) return;
        if (!ok) {
          addBlobFallback(s);
          return;
        }
        if (s.content === s.blob && s.blob) { // geç gelen model blob'un yerini alır
          s.spin.remove(s.blob);
          disposeObject(s.blob);
          s.blob = null;
          s.content = null;
        }
        s.current = 0;
        showFirst(s, s.models[0]);
      });
    }
    if (document.readyState !== 'complete') {
      var onLoad = function () { begin(); };
      window.addEventListener('load', onLoad, { once: true });
      s.off.push(function () { window.removeEventListener('load', onLoad); });
      return;
    }
    begin();
  }

  /* ---------- Sürükleme (§8.4) ---------- */
  function bindDrag(s, canvas) {
    var drag = null; // {id, x, y, lastX, lastY, lastT, mode: pending|rotate|scroll}

    function startRotate(pointerId) {
      drag.mode = 'rotate';
      if (canvas.setPointerCapture) {
        try { canvas.setPointerCapture(pointerId); } catch (e) { /* önemsiz */ }
      }
      s.dragging = true;
      s.vel = 0;
      s.stage.classList.add('is-dragging');
      s.lastInteractAt = performance.now();
      ensureLoop(s);
    }

    function onDown(e) {
      // drag doluysa ikinci parmağı yok say — aksi hâlde ilk parmağın up'ı
      // id eşleşmeyince kaçar ve s.dragging asılı kalırdı
      if (state !== s || drag || (e.button !== undefined && e.button !== 0)) return;
      drag = {
        id: e.pointerId, x: e.clientX, y: e.clientY,
        lastX: e.clientX, lastY: e.clientY, lastT: e.timeStamp,
        mode: e.pointerType === 'touch' ? 'pending' : 'rotate'
      };
      if (drag.mode === 'rotate') {
        startRotate(e.pointerId);
        e.preventDefault(); // fare: metin seçimini engelle (touch'ta çağrılmaz)
      }
    }

    function onMove(e) {
      if (!drag || e.pointerId !== drag.id) return;

      // Yön kilidi: baskın yatay jest modeli döndürür, dikey jest sayfaya
      // gider (touch-action: pan-y tarayıcıya dikey pan hakkını zaten verir;
      // tarayıcı kaydırmayı devralınca pointercancel gelir)
      if (drag.mode === 'pending') {
        var dx0 = e.clientX - drag.x;
        var dy0 = e.clientY - drag.y;
        if (Math.abs(dx0) < LOCK_PX && Math.abs(dy0) < LOCK_PX) return;
        if (Math.abs(dx0) > Math.abs(dy0) * 1.15) {
          startRotate(e.pointerId);
          drag.lastX = e.clientX;
          drag.lastY = e.clientY;
          drag.lastT = e.timeStamp;
        } else {
          drag.mode = 'scroll';
        }
        return;
      }
      if (drag.mode !== 'rotate') return;

      var dx = e.clientX - drag.lastX;
      var dy = e.clientY - drag.lastY;
      var dtMs = Math.max(1, e.timeStamp - drag.lastT);
      drag.lastX = e.clientX;
      drag.lastY = e.clientY;
      drag.lastT = e.timeStamp;

      s.yaw += dx * DRAG_K;                                     // 360° serbest
      s.pitch = clamp(s.pitch + dy * PITCH_K, -PITCH_MAX, PITCH_MAX);
      s.vel = s.vel * 0.6 + (dx * DRAG_K) / (dtMs / 1000) * 0.4; // atalet için süzülmüş hız
      s.lastInteractAt = performance.now();
    }

    function onUp(e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (drag.mode === 'rotate') {
        s.dragging = false;
        s.stage.classList.remove('is-dragging');
        // Fırlatıp DURDURUP bırakan kullanıcıya bayat hız uygulanmasın
        if (e.timeStamp - drag.lastT > 100) s.vel = 0;
        s.vel = clamp(s.vel, -6, 6);
        s.lastInteractAt = performance.now();
        ensureLoop(s);
      }
      drag = null;
    }

    canvas.addEventListener('pointerdown', onDown);
    canvas.addEventListener('pointermove', onMove);
    canvas.addEventListener('pointerup', onUp);
    canvas.addEventListener('pointercancel', onUp);
    s.off.push(function () {
      canvas.removeEventListener('pointerdown', onDown);
      canvas.removeEventListener('pointermove', onMove);
      canvas.removeEventListener('pointerup', onUp);
      canvas.removeEventListener('pointercancel', onUp);
    });
  }

  /* ---------- Sahne kurulumu ---------- */
  function srgb(hex) {
    // r128: renderer sRGB çıkışında materyal/ışık renkleri lineere çevrilir
    // ki eski (dönüşümsüz) pipeline'daki görünüm korunsun
    return new THREE.Color(hex).convertSRGBToLinear();
  }

  function init3D(stage) {
    var s = {
      stage: stage,
      off: [],
      io: null,
      raf: 0,
      watchdog: 0,
      loadTimer: 0,
      frames: 0,
      running: false,
      onScreen: false,
      tabVisible: !document.hidden,
      mouseX: 0,
      mouseY: 0,
      t: 0,
      yaw: 0,
      pitch: 0,
      vel: 0,
      dragging: false,
      autoFactor: 1, // sayfa açılışında rampasız döner (eski davranış)
      lastInteractAt: -1e9,
      lastTickAt: 0,
      fade: null,
      xfade: null,
      rotNextAt: 0,
      models: [],
      current: -1,
      blob: null,
      content: null
    };

    s.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    // 16.2 kalite kararı (VITRIN 14.x'ten taşındı): DPR sınırı BİLİNÇLİ YOK —
    // tam retina. iPhone 11'de test edildi; yavaş cihaz kısma sırası CLAUDE.md'de.
    s.renderer.setPixelRatio(window.devicePixelRatio || 1);
    s.renderer.shadowMap.enabled = true;
    s.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    // GLB dokuları sRGB işaretli gelir; çıkış da sRGB olmalı (aşağıda srgb()
    // dönüşümleri podyum/ışık renklerinin eski görünümünü korur)
    s.renderer.outputEncoding = THREE.sRGBEncoding;
    stage.appendChild(s.renderer.domElement);

    var scene = new THREE.Scene();
    s.scene = scene;
    var camera = new THREE.PerspectiveCamera(34, 1, 0.1, 50);
    camera.position.set(0, 1.15, 6.4);
    camera.lookAt(0, 0.3, 0);
    s.camera = camera;

    var hemi = new THREE.HemisphereLight(0xffffff, 0x888888, 0.55);
    hemi.color.convertSRGBToLinear();
    hemi.groundColor.convertSRGBToLinear();
    scene.add(hemi);

    // Spot #eaf0ff, rim #e0d2ff (CLAUDE.md §3)
    var spot = new THREE.SpotLight(0xeaf0ff, 1.25, 30, Math.PI / 5, 0.45, 1);
    spot.color.convertSRGBToLinear();
    spot.position.set(2.4, 6.2, 3.2);
    spot.castShadow = true;
    spot.shadow.mapSize.width = 1024;
    spot.shadow.mapSize.height = 1024;
    scene.add(spot);

    var rim = new THREE.DirectionalLight(0xe0d2ff, 0.5);
    rim.color.convertSRGBToLinear();
    rim.position.set(-3, 2.2, -3.5);
    scene.add(rim);

    // rig (parallax) > tilt (±15° eğim) > spin (360° yaw) > içerik
    var rig = new THREE.Group();
    var tilt = new THREE.Group();
    var spin = new THREE.Group();
    tilt.position.y = PIVOT_Y;   // eğim pivotu gövde merkezinde
    spin.position.y = -PIVOT_Y;
    tilt.add(spin);
    rig.add(tilt);
    scene.add(rig);
    s.rig = rig;
    s.tilt = tilt;
    s.spin = spin;

    // Kaide #c7d0e4 (CLAUDE.md §3)
    var pedestal = new THREE.Mesh(
      new THREE.CylinderGeometry(1.5, 1.62, 0.42, 64),
      new THREE.MeshStandardMaterial({ color: srgb(0xc7d0e4), roughness: 0.85, metalness: 0.05 })
    );
    pedestal.position.y = -0.42;
    pedestal.receiveShadow = true;
    scene.add(pedestal);

    var ring = new THREE.Mesh(
      new THREE.CylinderGeometry(1.53, 1.53, 0.05, 64),
      new THREE.MeshStandardMaterial({ color: srgb(0x8f9dff), roughness: 0.4, metalness: 0.25 })
    );
    ring.position.y = -0.19;
    scene.add(ring);

    var ground = new THREE.Mesh(
      new THREE.CircleGeometry(4.5, 48),
      new THREE.ShadowMaterial({ opacity: 0.22 })
    );
    ground.rotation.x = -Math.PI / 2;
    ground.position.y = -0.63;
    ground.receiveShadow = true;
    scene.add(ground);

    function fit() {
      var w = stage.clientWidth, h = stage.clientHeight;
      if (!w || !h) return;
      s.renderer.setSize(w, h);
      camera.aspect = w / h;
      camera.updateProjectionMatrix();
      if (!s.raf) render(s); // döngü kapalıyken statik kareyi tazele
    }

    var onResize = function () { fit(); };
    window.addEventListener('resize', onResize);
    s.off.push(function () { window.removeEventListener('resize', onResize); });

    fit();

    // Görünürlükten bağımsız İLK KAREYİ hemen çiz (podyum + ışık anında):
    // - watchdog yanlış alarm vermez (sayfa hero'ya scroll'lu açılsa bile)
    // - reduced-motion statik pozunu da bu kare verir
    render(s);

    // Watchdog: 3 sn içinde hiç frame çizilmediyse fallback.
    // render() yukarıda senkron çağrıldığı için normalde asla tetiklenmez.
    s.watchdog = setTimeout(function () {
      if (state === s && s.frames === 0) {
        teardown();
        setNo3d(true);
      }
    }, 3000);

    state = s;

    // İçerik: vitrin listesi varsa GLB'ler (podyum çizilmeye devam eder), yoksa blob
    s.models = readVitrinList(stage);
    loadFirst(s);

    bindDrag(s, s.renderer.domElement);

    // Sekme arka planda -> render durur (§8.4)
    var onVis = function () {
      s.tabVisible = !document.hidden;
      ensureLoop(s);
    };
    document.addEventListener('visibilitychange', onVis);
    s.off.push(function () { document.removeEventListener('visibilitychange', onVis); });

    var onMove = function (e) {
      s.mouseX = (e.clientX / window.innerWidth - 0.5) * 2;
      s.mouseY = (e.clientY / window.innerHeight - 0.5) * 2;
    };
    window.addEventListener('pointermove', onMove);
    s.off.push(function () { window.removeEventListener('pointermove', onMove); });

    // Sahne ekrandayken çalış, çıkınca dur (boşa frame yok)
    if ('IntersectionObserver' in window) {
      s.io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          s.onScreen = entries[i].isIntersecting;
        }
        ensureLoop(s);
      }, { threshold: 0.05 });
      s.io.observe(stage);
    } else {
      s.onScreen = true;
      ensureLoop(s);
    }
  }

  /* ---------- Başlatma ---------- */
  function boot(stage) {
    if (!stage || stage.dataset.y2kInit) return; // çift init koruması
    stage.dataset.y2kInit = '1';

    var startedHere = false; // IO + emniyet kemeri aynı anda çağırsa da tek init
    function start() {
      if (startedHere) return;
      startedHere = true;
      try {
        if (!window.THREE) throw new Error('three.min.js yüklenmedi');
        init3D(stage);
      } catch (err) {
        setNo3d(true);
      }
    }

    // Emniyet kemeri: herhangi bir nedenle (gizli/0 boyutlu sahne, IO hiç
    // tetiklenmedi...) 3 sn içinde init olmamışsa zorla başlat; 1 sn sonra
    // hâlâ frame çizilmemişse fallback. "Ne 3D ne fallback" durumu imkânsız.
    setTimeout(function () {
      if (!document.body.contains(stage)) return; // editörde söküldüyse dokunma
      start();
      setTimeout(function () {
        if (!document.body.contains(stage)) return;
        if (!state || state.stage !== stage || state.frames === 0) {
          teardown();
          setNo3d(true);
        }
      }, 1000);
    }, 3000);

    // Editörde IO bekleme; storefront'ta sahne görünür olunca init
    // (LCP'yi bekletmez — LCP hero metnidir)
    if (!isDesignMode() && 'IntersectionObserver' in window) {
      var initIO = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            initIO.disconnect();
            start();
            return;
          }
        }
      }, { threshold: 0.1 });
      initIO.observe(stage);
    } else {
      start();
    }
  }

  /* ---------- Tema editörü olayları ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    var stage = e.target && e.target.querySelector ? e.target.querySelector('[data-y2k-stage]') : null;
    if (stage) {
      // Yalnız aktif sahnenin stage'i DOM'dan söküldüyse (aynı section'ın
      // editör reload'u) sök; yaşayan bir sahneyi başka bir instance öldürmesin
      // (schema "limit": 1 zaten ikinci instance'ı engeller — çifte emniyet)
      if (state && !document.body.contains(state.stage)) teardown();
      if (!state) boot(stage);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var hadStage = e.target && e.target.querySelector ? e.target.querySelector('[data-y2k-stage]') : null;
    if (hadStage || (state && !document.body.contains(state.stage))) {
      teardown();
    }
  });

  boot(document.querySelector('[data-y2k-stage]'));
})();
